import { Flex, GapSize } from "@/components/atoms/flex";
import { useStyle } from "./style";
import { useIntl } from "react-intl";
import { ClearableInput } from "@/components/atoms/clearableInput";
import { useEffect, useState } from "react";
import { Search24Regular } from "@fluentui/react-icons";
import { PopoverView } from "@/components/atoms/popover";
import { Settings20Regular } from "@fluentui/react-icons";
import { Divider } from "@fluentui/react-components";
import {
	SupervisorSettings,
	SupervisorAgentFilter,
} from "@/components/organisms/supervisor";
import { Button } from "@fluentui/react-components";
import { SupervisorQueueFilter } from "@/components/molecules/queueFilter/SupervisorQueueFilter";
import { TableType } from "@/common/types";
import {
	AppCacheActions,
	CacheKey,
	useAppCacheStore,
	AppCacheState,
} from "@/common/stores/persistingStores/app";
import {
	SupervisorAgentsFilterActions,
	useSupervisorAgentsFilterStore,
} from "@/common/stores/nonpersistingStores/supervisorAgentsFilter";
import {
	InteractionFilterState,
	useInteractionFilterStore,
} from "@/common/stores/nonpersistingStores/interactionfilter";

export const SupervisorPanelHeader = (props: {
	additionalActions?: JSX.Element[];
	hideSettingsButton?: boolean;
}) => {
	const classes = useStyle();
	const intl = useIntl();

	const appStoreActions = useAppCacheStore((state: AppCacheActions) => state);
	const appStoreCache = useAppCacheStore((state: AppCacheState) => state.cache);

	const filterData = useInteractionFilterStore(
		(state: InteractionFilterState) => state.active
	);

	const supervisorAgentsFilterActions = useSupervisorAgentsFilterStore(
		(actions: SupervisorAgentsFilterActions) => actions
	);

	const [searchText, setSearchText] = useState<string>("");

	useEffect(() => {
		if (
			searchText === "" &&
			appStoreCache[CacheKey.SupervisorAgentsFilterData].searchText !== ""
		) {
			setSearchText(
				appStoreCache[CacheKey.SupervisorAgentsFilterData].searchText
			);
		}
	}, [appStoreCache[CacheKey.SupervisorAgentsFilterData]]);

	useEffect(() => {
		const filterData = appStoreCache[CacheKey.SupervisorAgentsFilterData];
		if (filterData.searchText != searchText) {
			filterData.searchText = searchText;

			appStoreActions.setCache(CacheKey.SupervisorAgentsFilterData, {
				...filterData,
			});
			supervisorAgentsFilterActions.setSearchText(searchText);
		}
	}, [searchText]);

	return (
		<Flex className={classes.container} hAlign={"space-between"}>
			<ClearableInput
				clearable
				value={searchText}
				className={classes.searchInput}
				placeholder={intl.formatMessage({
					id: "Supervisor.Filters.SearchPlaceholder",
				})}
				contentAfter={<Search24Regular />}
				onChange={setSearchText}
			/>
			<Flex className={classes.rightContainer}>
				<Flex gap={GapSize.Large}>
					{props.additionalActions ? <>{...props.additionalActions}</> : <></>}
				</Flex>
				<Flex>
					<SupervisorAgentFilter />
					<SupervisorQueueFilter
						cacheKey={CacheKey.SupervisorAgentsFilterData}
						type={TableType.SupervisorAgents}
						filterData={filterData}
					/>
				</Flex>
				{!props.hideSettingsButton && (
					<>
						<Divider vertical />
						<PopoverView
							classes={{ content: classes.settingsPopover }}
							positioning={{
								position: "below",
								align: "end",
							}}
							trigger={
								<Button
									appearance="transparent"
									icon={<Settings20Regular />}
									onClick={(e) => {
										e.preventDefault();
									}}
									className={classes.filterTrigger}
								/>
							}
							content={<SupervisorSettings />}
						/>
					</>
				)}
			</Flex>
		</Flex>
	);
};
